import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { useAuthStore } from '../../store/storeAuth';
import {
  EffortValue,
  getEffortCapability,
} from '../AiConfigs/modelEffortCapabilities';

interface EffortSelectorProps {
  aiSystem: string;
  aiModel: string;
  value: EffortValue | string | undefined;
  onChange: (event: { target: { name: string; value: string } }) => void;
}

const EFFORT_LABELS: Record<EffortValue, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};

const EffortSelector = ({
  aiSystem,
  aiModel,
  value,
  onChange,
}: EffortSelectorProps) => {
  const { user } = useAuthStore(state => state);
  const capability = getEffortCapability(aiSystem, aiModel);
  if (!capability.supportsEffort) return null;
  const isValidValue = capability.effortOptions.includes(value as EffortValue);
  const effective = isValidValue
    ? (value as EffortValue)
    : capability.defaultEffort;
  return (
    <Box mt={'8px'}>
      <Typography
        fontSize={'14px'}
        fontWeight={500}
        sx={{
          mb: '4px',
          color: user?.theme === 'dark' ? '#D0D5DD' : 'black',
        }}
        variant='body1'
      >
        Effort
      </Typography>
      <FormControl sx={{ width: '100%' }}>
        <Select
          className='nodrag'
          name='aiEffort'
          fullWidth
          size='small'
          value={effective}
          sx={{
            height: 'unset',
            bgcolor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
            color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
          }}
          onChange={event =>
            onChange({
              target: { name: 'aiEffort', value: String(event.target.value) },
            })
          }
          MenuProps={{
            style: {
              maxHeight: '700px',
            },
          }}
        >
          {capability.effortOptions.map(option => (
            <MenuItem key={option} className='nodrag' value={option}>
              <Typography>{EFFORT_LABELS[option]}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default EffortSelector;
